import { defineAction } from '~/prix'
import updateQuestionnaireAction from './questionnaireUpdate.action.json' with { type: 'json' }
import { z } from 'zod'
import { questionnaireObject } from '../questionnaireObject'

const updateQuestionnaireDefinition = defineAction({
  ...updateQuestionnaireAction,
  input: questionnaireObject,
  output: z.object({
    success: z.boolean().describe('Indica se o formulário foi alterado com sucesso.'),
  }),
})

export default updateQuestionnaireDefinition
